import { actionButtonComponents } from '@/features/reports/constants/actionButton.constant';
import { ReportsMineData } from '@/features/reports/types/reportsMine.type';
import { formatDateTime } from '../../../common/utils/formatters';

export class ReportsMineTransformer {
  static tableTransformer() {
    return (reports: ReportsMineData[]) => {
      return reports.map((report) => {
        return {
          title: report.title,
          result_type: report.result_type,
          created_at: report.created_at ? formatDateTime(new Date(report?.created_at)) : null,
          action: actionButtonComponents(report)[report?.status as keyof typeof actionButtonComponents],
        };
      });
    };
  }
}
